/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AwardDto from './AwardDto';
import BisacDto from './BisacDto';
import BookDto from './BookDto';
import CategoryDto from './CategoryDto';
import LanguageDto from './LanguageDto';
import LocationDto from './LocationDto';
import OrganizationIdDto from './OrganizationIdDto';
import PaginationModel from './PaginationModel';
import PlatformDto from './PlatformDto';
import ProductTypeDto from './ProductTypeDto';

/**
 * The BookInfoByOidResponseModel model module.
 * @module model/BookInfoByOidResponseModel
 * @version v1.0.0
 */
class BookInfoByOidResponseModel {
    /**
     * Constructs a new <code>BookInfoByOidResponseModel</code>.
     * @alias module:model/BookInfoByOidResponseModel
     */
    constructor() { 
        
        BookInfoByOidResponseModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookInfoByOidResponseModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookInfoByOidResponseModel} obj Optional instance to populate.
     * @return {module:model/BookInfoByOidResponseModel} The populated <code>BookInfoByOidResponseModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookInfoByOidResponseModel();

            if (data.hasOwnProperty('awards')) {
                obj['awards'] = ApiClient.convertToType(data['awards'], [AwardDto]);
            }
            if (data.hasOwnProperty('bisacs')) {
                obj['bisacs'] = ApiClient.convertToType(data['bisacs'], [BisacDto]);
            }
            if (data.hasOwnProperty('books')) {
                obj['books'] = ApiClient.convertToType(data['books'], [BookDto]);
            }
            if (data.hasOwnProperty('categories')) {
                obj['categories'] = ApiClient.convertToType(data['categories'], [CategoryDto]);
            }
            if (data.hasOwnProperty('languages')) {
                obj['languages'] = ApiClient.convertToType(data['languages'], [LanguageDto]);
            }
            if (data.hasOwnProperty('locations')) {
                obj['locations'] = ApiClient.convertToType(data['locations'], [LocationDto]);
            }
            if (data.hasOwnProperty('organizations')) {
                obj['organizations'] = ApiClient.convertToType(data['organizations'], [OrganizationIdDto]);
            }
            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('platforms')) {
                obj['platforms'] = ApiClient.convertToType(data['platforms'], [PlatformDto]);
            }
            if (data.hasOwnProperty('productTypes')) {
                obj['productTypes'] = ApiClient.convertToType(data['productTypes'], [ProductTypeDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/AwardDto>} awards
 */
BookInfoByOidResponseModel.prototype['awards'] = undefined;

/**
 * @member {Array.<module:model/BisacDto>} bisacs
 */
BookInfoByOidResponseModel.prototype['bisacs'] = undefined;

/**
 * @member {Array.<module:model/BookDto>} books
 */
BookInfoByOidResponseModel.prototype['books'] = undefined;

/**
 * @member {Array.<module:model/CategoryDto>} categories
 */
BookInfoByOidResponseModel.prototype['categories'] = undefined;

/**
 * @member {Array.<module:model/LanguageDto>} languages
 */
BookInfoByOidResponseModel.prototype['languages'] = undefined;

/**
 * @member {Array.<module:model/LocationDto>} locations
 */
BookInfoByOidResponseModel.prototype['locations'] = undefined;

/**
 * @member {Array.<module:model/OrganizationIdDto>} organizations
 */
BookInfoByOidResponseModel.prototype['organizations'] = undefined;

/**
 * @member {module:model/PaginationModel} pagination
 */
BookInfoByOidResponseModel.prototype['pagination'] = undefined;

/**
 * @member {Array.<module:model/PlatformDto>} platforms
 */
BookInfoByOidResponseModel.prototype['platforms'] = undefined;

/**
 * @member {Array.<module:model/ProductTypeDto>} productTypes
 */
BookInfoByOidResponseModel.prototype['productTypes'] = undefined;






export default BookInfoByOidResponseModel;

